import { AxiosGlobalFilters } from '../config';

function getEmpresaId() {
  const value = `; ${document.cookie}`;
  const parts = value.split('; companies=');
  if (parts.length !== 2) return undefined;
  try {
    return JSON.parse(decodeURIComponent(parts.pop().split(';').shift()))?.id;
  } catch {
    return undefined;
  }
}

function headers() {
  const empresaId = getEmpresaId();
  return empresaId ? { EmpresaId: empresaId } : {};
}

export const AlmoxarifadoService = {
  listarAlmoxarifados: () => AxiosGlobalFilters({ method: 'GET', url: '/v1/almoxarifados', headers: headers() }),

  // Só traz almoxarifado que tem o material em questão (ou da unidade, se materialId não
  // for informado) — é o filtro certo pro combo de Almoxarifado no modal de correção.
  listarAlmoxarifadosAtivos: ({ siteId, materialId } = {}) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/almoxarifados/ativos',
      params: { siteId, materialId },
      headers: headers(),
    }),

  listarUsuarios: () => AxiosGlobalFilters({ method: 'GET', url: '/v1/usuarios', headers: headers() }),

  listarFornecedores: () => AxiosGlobalFilters({ method: 'GET', url: '/v1/empresas/fornecedor', headers: headers() }),

  listarMateriais: ({ almoxarifadoId, unidadeId } = {}) =>
    AxiosGlobalFilters({
      method: 'GET',
      url: '/v1/materiais',
      params: almoxarifadoId ? { almoxarifadoId } : undefined,
      headers: { ...headers(), ...(unidadeId ? { UnidadeId: unidadeId } : {}) },
    }),
};
